export const TASK = "TASK";
export const TASK_SUCCESS = "TASK_SUCCESS";
export const TASK_FAILED = "TASK_FAILED";

export const FILTERED_TASK = "FILTERED_TASK";
export const FILTERED_TASK_SUCCESS = "FILTERED_TASK_SUCCESS";
export const FILTERED_TASK_FAILED = "FILTERED_TASK_FAILED";

export const ADD_TASK = "ADD_TASK";
export const ADD_TASK_SUCCESS = "ADD_TASK_SUCCESS";
export const ADD_TASK_FAILED = "ADD_TASK_FAILED";

export const UPDATE_TASK = "UPDATE_TASK";
export const UPDATE_TASK_SUCCESS = "UPDATE_TASK_SUCCESS";
export const UPDATE_TASK_FAILED = "UPDATE_TASK_FAILED";

export const DELETE_TASK = "DELETE_TASK";
export const DELETE_TASK_SUCCESS = "DELETE_TASK_SUCCESS";
export const DELETE_TASK_FAILED = "DELETE_TASK_FAILED";

export const TASK_CATEGORY = "TASK_CATEGORY";
export const TASK_CATEGORY_SUCCESS = "TASK_CATEGORY_SUCCESS";
export const TASK_CATEGORY_FAILED = "TASK_CATEGORY_FAILED";

export const ADD_TASK_CATEGORY = "ADD_TASK_CATEGORY";
export const ADD_TASK_CATEGORY_SUCCESS = "ADD_TASK_CATEGORY_SUCCESS";
export const ADD_TASK_CATEGORY_FAILED = "ADD_TASK_CATEGORY_FAILED";

export const DELETE_TASK_CATEGORY = "DELETE_TASK_CATEGORY";
export const DELETE_TASK_CATEGORY_SUCCESS = "DELETE_TASK_CATEGORY_SUCCESS";
export const DELETE_TASK_CATEGORY_FAILED = "DELETE_TASK_CATEGORY_FAILED";

export const TASK_LABEL = "TASK_LABEL";
export const TASK_LABEL_SUCCESS = "TASK_LABEL_SUCCESS";
export const TASK_LABEL_FAILED = "TASK_LABEL_FAILED";

export const ADD_TASK_LABEL = "ADD_TASK_LABEL";
export const ADD_TASK_LABEL_SUCCESS = "ADD_TASK_LABEL_SUCCESS";
export const ADD_TASK_LABEL_FAILED = "ADD_TASK_LABEL_FAILED";

export const UPDATE_TASK_LABEL = "UPDATE_TASK_LABEL";
export const UPDATE_TASK_LABEL_SUCCESS = "UPDATE_TASK_LABEL_SUCCESS";
export const UPDATE_TASK_LABEL_FAILED = "UPDATE_TASK_LABEL_FAILED";

export const DELETE_TASK_LABEL = "DELETE_TASK_LABEL";
export const DELETE_TASK_LABEL_SUCCESS = "DELETE_TASK_LABEL_SUCCESS";
export const DELETE_TASK_LABEL_FAILED = "DELETE_TASK_LABEL_FAILED";

export const TASK_FILES = "TASK_FILES";
export const TASK_FILES_SUCCESS = "TASK_FILES_SUCCESS";
export const TASK_FILES_FAILED = "TASK_FILES_FAILED";

export const ADD_TASK_FILES = "ADD_TASK_FILES";
export const ADD_TASK_FILES_SUCCESS = "ADD_TASK_FILES_SUCCESS";
export const ADD_TASK_FILES_FAILED = "ADD_TASK_FILES_FAILED";

export const UPDATE_TASK_FILES = "UPDATE_TASK_FILES";
export const UPDATE_TASK_FILES_SUCCESS = "UPDATE_TASK_FILES_SUCCESS";
export const UPDATE_TASK_FILES_FAILED = "UPDATE_TASK_FILES_FAILED";

export const DELETE_TASK_FILES = "DELETE_TASK_FILES";
export const DELETE_TASK_FILES_SUCCESS = "DELETE_TASK_FILES_SUCCESS";
export const DELETE_TASK_FILES_FAILED = "DELETE_TASK_FILES_FAILED";

export const SUB_TASK = "SUB_TASK";
export const SUB_TASK_SUCCESS = "SUB_TASK_SUCCESS";
export const SUB_TASK_FAILED = "SUB_TASK_FAILED";

export const ADD_SUB_TASK = "ADD_SUB_TASK";
export const ADD_SUB_TASK_SUCCESS = "ADD_SUB_TASK_SUCCESS";
export const ADD_SUB_TASK_FAILED = "ADD_SUB_TASK_FAILED";

export const UPDATE_SUB_TASK = "UPDATE_SUB_TASK";
export const UPDATE_SUB_TASK_SUCCESS = "UPDATE_SUB_TASK_SUCCESS";
export const UPDATE_SUB_TASK_FAILED = "UPDATE_SUB_TASK_FAILED";

export const DELETE_SUB_TASK = "DELETE_SUB_TASK";
export const DELETE_SUB_TASK_SUCCESS = "DELETE_SUB_TASK_SUCCESS";
export const DELETE_SUB_TASK_FAILED = "DELETE_SUB_TASK_FAILED";

export const TASK_STATUS = "TASK_STATUS";
export const TASK_STATUS_SUCCESS = "TASK_STATUS_SUCCESS";
export const TASK_STATUS_FAILED = "TASK_STATUS_FAILED";

export const ADD_TASK_STATUS = "ADD_TASK_STATUS";
export const ADD_TASK_STATUS_SUCCESS = "ADD_TASK_STATUS_SUCCESS";
export const ADD_TASK_STATUS_FAILED = "ADD_TASK_STATUS_FAILED";

export const UPDATE_TASK_STATUS = "UPDATE_TASK_STATUS";
export const UPDATE_TASK_STATUS_SUCCESS = "UPDATE_TASK_STATUS_SUCCESS";
export const UPDATE_TASK_STATUS_FAILED = "UPDATE_TASK_STATUS_FAILED";

export const DELETE_TASK_STATUS = "DELETE_TASK_STATUS";
export const DELETE_TASK_STATUS_SUCCESS = "DELETE_TASK_STATUS_SUCCESS";
export const DELETE_TASK_STATUS_FAILED = "DELETE_TASK_STATUS_FAILED";

export const CLEAR_ADD_TASK_STATUS = "CLEAR_ADD_TASK_STATUS";

export const RUNNING_TASK = "RUNNING_TASK";
export const RUNNING_TASK_SUCCESS = "RUNNING_TASK_SUCCESS";
export const RUNNING_TASK_FAILED = "RUNNING_TASK_FAILED";